import React from 'react';
import './contactStyle.css';
import { IoLogoWhatsapp } from "react-icons/io";
import { MdOutlineEmail } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa";
import H2Title from './../../../../components/text/h2Title/h2Title'
import NormalText from './../../../../components/text/normalText'

export default function Contact({title, email, linkedin, whatsapp, text}) {

    return (
        <section className='contact__container'>
            <H2Title title={title} />
            
            <div className='contact__content'>
                
               <div className='contact_icons-area'>
                    <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer"><MdOutlineEmail className="icon-link" color="black"/></a>
                    <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer"><IoLogoWhatsapp className="icon-link" color="black"/></a>
                    <a href={linkedin} target="_blank" rel="noopener noreferrer"><FaLinkedin className="icon-link" color="black"/></a>
               </div>

               <NormalText text={text} />

            </div>

        </section>
    );
}
